import { Link } from 'solito/link';
import type {
  IActionDataModel,
  IAdaptiveActionCard,
  IQuestionAnswer,
} from '@ninjacart/nc-nk-core';
import { getLanguageFromTags } from '../server/getQnaData';
import { Text, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { normalizeTextContent, truncateName } from '@ninjacart/nc-nk-store';

type QnaCard = IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>;

type AllQnaListProps = {
  questions: QnaCard[];
  fallbackLanguage?: string;
};

export function AllQnaList({ questions, fallbackLanguage = 'en' }: AllQnaListProps) {
  if (!questions?.length) {
    return (
      <Text paddingVertical={48} textAlign="center" color="$gray">
        No questions found.
      </Text>
    );
  }

  return (
    <YStack gap={16}>
      {questions.map((item) => {
        const content = item?.actionData?.content;
        if (!content?.id) return null;

        const tags = Array.isArray(content.tags)
          ? content.tags
          : content?.tags
            ? [content.tags]
            : [];
        const language = getLanguageFromTags(tags) ?? fallbackLanguage;
        const href = `/${language}/qna/${content.id}`;
        const titleText =
          content.title?.trim() || normalizeTextContent(content.body, true) || 'Untitled question';
        const title = truncateName(titleText, 40);

        return (
          <XStack key={content.id} gap={8} alignItems="flex-start">
            <Text color="$usertextColor" fontSize={18} lineHeight={20}>
              •
            </Text>
            <Link href={href} style={{ flex: 1 }}>
              <Text
                textDecorationLine="underline"
                color="$usertextColor"
                fontSize={18}
                fontWeight="500"
                lineHeight={20}
                numberOfLines={1}
                ellipse
                cursor="pointer"
              >
                {title}
              </Text>
            </Link>
          </XStack>
        );
      })}
    </YStack>
  );
}

